import type { DriveStep } from 'driver.js';

export const doctorInvoicesSteps: DriveStep[] = [
  {
    element: '[data-tour="doctor-invoices-create"]',
    popover: {
      title: 'Create Invoices',
      description: 'Create an invoice linked to a case. Add line items for services rendered.',
      side: 'left',
      align: 'center',
    },
  },
  {
    element: '[data-tour="doctor-invoices-stats"]',
    popover: {
      title: 'Revenue Overview',
      description: "Total revenue, previous month's earnings, and outstanding amounts.",
      side: 'bottom',
      align: 'center',
    },
  },
  {
    element: '[data-tour="doctor-invoices-search"]',
    popover: {
      title: 'Find Invoices',
      description: 'Search by number, client, or case. Filter by status.',
      side: 'bottom',
      align: 'center',
    },
  },
  {
    element: '[data-tour="doctor-invoices-table"]',
    popover: {
      title: 'Invoice Actions',
      description:
        'Edit, send to client, mark paid, download PDF, or delete. Stripe Connect required.',
      side: 'top',
      align: 'center',
    },
  },
];
